import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

// Connects to data-controller="preview-form"
export class PreviewFormController extends Controller {
  static targets = ["form"];
  static values = { ticketType: String };

  request(attributes) {
    const formData = new FormData(this.formTarget);
    const ticketTypeElement = Array.from(document.getElementsByName("master_ticket_form[ticket_type]")).find(
      (radio) => radio.checked,
    );

    formData.append("preview_tickets[ticket_type]", ticketTypeElement ? ticketTypeElement.value : this.ticketTypeValue);
    formData.append("preview_tickets[name]", attributes["name"]);
    formData.append("preview_tickets[price]", attributes["price"]);
    formData.append("preview_tickets[selected_color]", attributes["selectedColor"]);
    formData.append("preview_tickets[color]", attributes["color"]);
    formData.append("preview_tickets[note]", attributes["note"]);

    post(this.formTarget.action, {
      body: formData,
      responseKind: "turbo-stream",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("プレビューに失敗しました。");
        }
      })
      .catch((error) => {
        alert(error.message);
      });
  }
}

// Connects to data-controller="ticket"
export class TicketController extends Controller {
  static targets = ["name", "price", "selectedColor", "color", "note"];
  static outlets = ["preview-form"];

  preview(event) {
    event.preventDefault();

    const colorElement = this.colorTargets.find((radio) => radio.checked);
    const attributes = {
      name: this.nameTarget.value,
      price: this.priceTarget.value,
      selectedColor: this.hasSelectedColorTarget && this.selectedColorTarget.checked ? "1" : "0",
      color: colorElement ? colorElement.value : "",
      note: this.noteTarget.value,
    };

    this.previewFormOutlet.request(attributes);
  }
}
